'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import {
//   LinkIcon
// } from '../../components'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _IyvListTable = require('./IyvListTable.css');

var _IyvListTable2 = _interopRequireDefault(_IyvListTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IyvListTdFossilGrade = (_dec = (0, _reactCssModules2.default)(_IyvListTable2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IyvListTdFossilGrade, _Component);

  //
  function IyvListTdFossilGrade(props) {
    (0, _classCallCheck3.default)(this, IyvListTdFossilGrade);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListTdFossilGrade.__proto__ || (0, _getPrototypeOf2.default)(IyvListTdFossilGrade)).call(this, props));
  }
  //


  (0, _createClass3.default)(IyvListTdFossilGrade, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'td',
        {
          styleName: 'col col-grade',
          onClick: this.props.clickShareclass(this.props.shareclass)
        },
        _react2.default.createElement(
          'div',
          { styleName: 'score-wrapper-w-tail fossil-w-tail-' + this.props.shareclass.grade_fossil },
          _react2.default.createElement(
            'span',
            { styleName: 'score-wrapper-grade' },
            {
              '-1': 'ERROR (1)',
              '0': 'ERROR (2)',
              '1': 'A',
              '1.5': 'ENGAGEMENT',
              '2': 'B',
              '3': 'C',
              '4': 'D',
              '5': 'F',
              '6': 'ERROR (3)'
            }[this.props.shareclass.grade_fossil] || 'ERROR (4)'
          ),
          _react2.default.createElement(
            'span',
            { styleName: 'score-wrapper-tail' },
            _format2.default.perc(this.props.shareclass.c2f5coogutweight)
          )
        )
      );
    }
  }]);
  return IyvListTdFossilGrade;
}(_react.Component), _class2.propTypes = {
  shareclass: _react.PropTypes.object.isRequired,
  clickShareclass: _react.PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = IyvListTdFossilGrade;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvListTable/IyvListTdFossilGrade.js
// module id = 1376
// module chunks = 0